import tw, { styled } from "twin.macro";

export const Wrapper = styled.div`
	${tw`p-4 md:p-6 h-full relative`}

	.midFadedBg {
		background: rgba(50, 50, 50, 0.5);
		backdrop-filter: blur(4px);
		border-radius: 50px;
	}
`;

export const TimelineContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
	/* @media (max-width: 1217px) {
			flex-direction: row;
			flex-wrap: nowrap;
			height: auto;
			overflow-x: scroll;
		} */
	/* } */
`;
